import { BaseNode } from '../canvas/element/node/common';
import { BaseEdge } from '../canvas/element/edge/common';
import { isUndefined } from 'lodash';
export const getElementCategory = (config) => {
    if (config instanceof BaseNode) {
        return 'NODE';
    }
    else if (config instanceof BaseEdge) {
        return 'EDGE';
    }
    else if (!isUndefined(config.source)) {
        return 'EDGE';
    }
    else if (!isUndefined(config.nodes)) {
        return 'GROUP';
    }
    else {
        return 'NODE';
    }
};
//# sourceMappingURL=common.js.map